import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackClosedAssetDetails.meta';

export type TrackClosedAssetDetailsParams = {
  asset_id: string;
  clip_id: string;
};

export const useTrackClosedAssetDetails = () => {
  const { track } = useAnalyticsUtilities();

  const trackClosedAssetDetails = useCallback(
    (params: TrackClosedAssetDetailsParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClosedAssetDetails };
};
